// extracted by mini-css-extract-plugin
export default {"editor-header":"IDE-topbar_editor-header__44aa6"};